export const studyPlan = {
  completedRate: 0,
  topics: [
    {
      group: { slug: "ciencias-exatas", name: "Ciências exatas" },
      lessons: { totalCount: 0, watchedCount: 0 },
      name: "Química",
      questions: { answeredCount: 0, totalCount: 0 },
      slug: "quimica"
    },
    {
      group: { slug: "ciencias-exatas", name: "Ciências exatas" },
      lessons: { totalCount: 0, watchedCount: 0 },
      name: "Geografia",
      questions: { answeredCount: 0, totalCount: 0 },
      slug: "geografia"
    },
    {
      group: { slug: "ciencias-exatas", name: "Ciências exatas" },
      lessons: { totalCount: 0, watchedCount: 0 },
      name: "Biologia",
      questions: { answeredCount: 0, totalCount: 0 },
      slug: "biologia"
    },
    {
      group: { slug: "ciencias-exatas", name: "Ciências exatas" },
      lessons: { totalCount: 0, watchedCount: 0 },
      name: "Matemática",
      questions: { answeredCount: 0, totalCount: 0 },
      slug: "matematica"
    }
  ]
};

export const subject = {
  completedRate: 0,
  group: { name: "Linguagens", slug: "linguagens" },
  name: "Inglês",
  slug: "ingles",
  topics: [
    {
      group: { name: "Linguagens", slug: "linguagens-0" },
      lessons: { totalCount: 1, watchedCount: 0 },
      name: "Pronomes",
      parent: { name: "Inglês", slug: "ingles" },
      questions: { answeredCount: 0, totalCount: 10 },
      slug: "pronomes-0"
    },
    {
      group: { name: "Linguagens", slug: "linguagens-1" },
      lessons: { totalCount: 1, watchedCount: 0 },
      name: "Pronomes",
      parent: { name: "Inglês", slug: "ingles" },
      questions: { answeredCount: 0, totalCount: 10 },
      slug: "pronomes-1"
    },
    {
      group: { name: "Linguagens", slug: "linguagens-2" },
      lessons: { totalCount: 1, watchedCount: 0 },
      name: "Pronomes",
      parent: { name: "Inglês", slug: "ingles" },
      questions: { answeredCount: 0, totalCount: 10 },
      slug: "pronomes-2"
    }
  ]
};
